module.exports = __webpack_public_path__ + "assets/emblem_navbar.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/emblem_navbar.png
 ** module id = 213
 ** module chunks = 1
 **/